const Event = () => {
  const eventList = [
    "/images/event1.png",
    "/images/event2.png",
    "/images/event3.png",
  ];
  return (
    <div
      id="event"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36 text-center text-black "
    >
      <p className="font-light text-xl lg:text-4xl">
        아무나&nbsp;장인이라 불리지&nbsp;않습니다
        <br />
        오직&nbsp;전문가만이 장인이라&nbsp;할&nbsp;수&nbsp;있습니다
      </p>
      <p className="font-light lg:text-2xl my-10">
        장인배관을&nbsp;선택해주신&nbsp;고객님들께서 후회하지&nbsp;않도록
      </p>
      <p className="font-light text-xl lg:text-4xl">
        <span className="text-primary">
          깔끔하게<span className="italic">!</span>&nbsp;&nbsp;100%
          <span className="italic">!</span>
        </span>
        &nbsp;&nbsp; 해결해드리겠습니다.
      </p>
      <div className="relative w-full h-full max-w-screen-xl mx-auto mt-14 grid grid-cols-1 lg:grid-cols-3 gap-5">
        {eventList.map((v, i) => (
          <div
            data-aos="fade-up"
            className=" relative w-full h-full rounded-3xl hover:-translate-y-3 hover:shadow-xl transition-all duration-300"
          >
            <img src={v} alt={`장인배관 누수·고압세척 시공 사례 ${i + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Event;
